import { css } from 'styled-components';
import { LoaderContainer } from 'modules/Loader/styled';
import { pxToRem } from 'modules/spacing';
const SIZE_MAP = {
    xs: 12,
    small: 14,
    medium: 16,
    large: 20,
};
export function getLoaderSize(size) {
    return css `
    ${LoaderContainer} {
      width: ${pxToRem(SIZE_MAP[size || 'medium'])};
      height: ${pxToRem(SIZE_MAP[size || 'medium'])};
    }
  `;
}
